import { useState, useEffect, useRef } from "react";

const DURATION = 300; // Duração da animação em milissegundos

export const useAnimateNumber = (endValue: number) => {
	const [currentValue, setCurrentValue] = useState(endValue);
	const prevEndValueRef = useRef(endValue);
	const animationFrameRef = useRef(0);

	useEffect(() => {
		const startValue = prevEndValueRef.current;
		const valueDifference = endValue - startValue;

		// Se o valor não mudou, não há necessidade de animar
		if (valueDifference === 0) {
			setCurrentValue(endValue);
			return;
		}

		const startTime = performance.now();

		const animate = (timestamp: number) => {
			const elapsedTime = timestamp - startTime;
			const progress = Math.min(elapsedTime / DURATION, 1);
			const newValue = startValue + valueDifference * progress;

			setCurrentValue(newValue);

			if (progress < 1) {
				animationFrameRef.current = requestAnimationFrame(animate);
			} else {
				// Ao final da animação, garante que o valor seja exatamente o final
				setCurrentValue(endValue);
				prevEndValueRef.current = endValue;
			}
		};

		animationFrameRef.current = requestAnimationFrame(animate);

		return () => cancelAnimationFrame(animationFrameRef.current);
	}, [endValue]);

	return currentValue;
};
